import React from 'react';
import PropTypes from 'prop-types';

function Boy({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M14.85 24.9016C12.8278 23.5509 11.3879 21.4886 10.8169 19.1247C9.11644 19.1039 8.43751 17.4378 8.43751 16.3128C8.43751 15.784 8.42963 13.5301 10.125 13.5003V11.3555"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M21.15 24.9016C23.1722 23.5509 24.6121 21.4886 25.1831 19.1247C26.8836 19.1039 27.5625 17.4378 27.5625 16.3128C27.5625 15.784 27.5704 13.5301 25.875 13.5003V11.3555"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M13.5 24.249V24.7496C13.5 25.8746 13.8375 27.5295 7.65562 28.6871C1.125 29.91 1.125 34.8746 1.125 34.8746H34.875C34.875 34.8746 34.875 30.0034 27.8876 28.6871C21.8604 27.5515 21.9375 25.8746 21.9375 24.7496V24.3458"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M11.25 27.6963C12.3924 28.8382 14.4602 31.4999 18 31.4999C21.5398 31.4999 23.7229 28.8905 24.75 27.8639"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M9 11.5528C9 11.5528 12.9375 7.87402 18 7.87402C23.0625 7.87402 27 11.4757 27 11.4757"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M9.41739 11.1963L11.25 13.5003C11.25 13.5003 14.6846 11.2503 18 11.2503C21.3154 11.2503 24.75 13.5003 24.75 13.5003L26.1563 10.8037"
        strokeLinecap="round"
      />
      <path
        strokeWidth={strokeWidth}
        stroke={stroke}
        d="M26.4375 13.6091C27.1238 12.9228 27 11.4761 27 11.4761V7.82154C27.0017 7.0021 26.7643 6.19997 26.3167 5.51353C25.8692 4.82709 25.2311 4.28619 24.4806 3.95716L18.6497 1.40735C18.4462 1.31839 18.2266 1.27246 18.0045 1.27246C17.7825 1.27246 17.5628 1.31839 17.3593 1.40735L11.5279 3.95716C10.7765 4.28581 10.1372 4.82638 9.6882 5.51272C9.23923 6.19906 9.00008 7.00139 9.00002 7.82154V11.5532C9.00002 11.5532 8.96402 13.0533 9.56252 13.6513"
        strokeLinecap="round"
      />
    </svg>
  );
}

Boy.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Boy;
